<div>
  <!-- ACTION BUTTONS -->
  <div style="margin-left: 80%; margin-bottom: 2%;">
    <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%;" mat-raised-button color="primary"
      printSectionId="print-section" [useExistingCss]="true" ngxPrint>
      Print
    </button>
    <button class="noPrint" style="margin-top: 2%; margin-left: 2%" (click)="exportExcel('issue_seller_Invoice_Register')"
      mat-raised-button color="primary">
      Export
    </button>
    <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
      Close
    </button>
  </div>

  <!-- PRINT SECTION -->
  <div id="print-section" style="margin-top: 30px; margin-left: 20px;">
    <table style="width: 100%; border-collapse: collapse; border: 1px solid #000;">
      <thead>
        <tr>
          <th colspan="15" style="text-align: center; font-weight: bold; font-size: 18px; padding: 8px; border: 1px solid #000;">
            हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक | Issue Register Report (In Details Office Representative)
          </th>
        </tr>
        <tr>
          <th colspan="7" style="text-align: left; padding: 5px; border: 1px solid #000;">Issue Date: {{ newissuedatepp }}</th>
          <th colspan="8" style="text-align: right; padding: 5px; border: 1px solid #000;">
            Date: From {{ start_date | date: 'dd-MM-yyyy' }} - To {{ end_date | date: 'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr>
          <th style="padding: 5px; border: 1px solid #000;">Sr</th>
          <th style="padding: 5px; border: 1px solid #000;">Booking Date</th>
          <th style="padding: 5px; border: 1px solid #000;">Booking No</th>
          <th style="padding: 5px; border: 1px solid #000;">Seller Name</th>
          <th style="padding: 5px; border: 1px solid #000;">Representative</th>
          <th style="padding: 5px; border: 1px solid #000;">Mobile No</th>
          <th style="padding: 5px; border: 1px solid #000;">Office Rep Name</th>
          <th style="padding: 5px; text-align: right; border: 1px solid #000;">Price</th>
          <th style="padding: 5px; text-align: right; border: 1px solid #000;">Copies</th>
          <th style="padding: 5px; text-align: right; border: 1px solid #000;">Total</th>
          <th style="padding: 5px; text-align: right; border: 1px solid #000;">Discount</th>
          <th style="padding: 5px; text-align: right; border: 1px solid #000;">Net Amt</th>
          <th style="padding: 5px; text-align: right; border: 1px solid #000;">जमा बाकी</th>
          <th style="padding: 5px; text-align: right; border: 1px solid #000;">येणे बाकी</th>
        </tr>
      </thead>

      <ng-container *ngFor="let report of filteredinDetailsRegReport; let reportIndex = index">
        <tbody>
          <tr>
            <td colspan="15" style="font-weight: bold; padding: 8px; border: 1px solid #000; background-color: #f0f0f0;">
              Group Sr: {{ reportIndex + 1 }} - {{ report.off_rep_name }}

            </td>
          </tr>

          <tr *ngFor="let item of report.advt_data; let itemIndex = index">
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ itemIndex + 1 }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ item.booking_date }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ item.booking_no }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ item.issue_seller_name }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ item.rep_name }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ item.rep_mob_no }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ item.off_rep_name }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ item.issue_amt }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ item.issue_copies }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ item.total_amt }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ item.disc_amt }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ item.amount }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ item.total_amt - item.remaingamt }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ item.remaingamt }}</td>
          </tr>

          <tr style="font-weight: bold; background-color: #e8f0ff;">
            <td colspan="7" style="text-align: right; padding: 5px; border: 1px solid #000;">Group Total</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ report.group_price_total | number: '1.2-2' }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ report.group_copies_total | number }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ report.group_issue_amt_total | number: '1.2-2' }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ report.group_discount_total | number: '1.2-2' }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ report.group_net_amt_total | number: '1.2-2' }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ report.group_received_total | number: '1.2-2' }}</td>
            <td style="padding: 5px; text-align: right; border: 1px solid #000;">{{ report.group_remaining_total | number: '1.2-2' }}</td>
          </tr>
        </tbody>
      </ng-container>

      <!-- Grand Totals -->
      <tfoot>
        <tr style="font-weight: bold; background-color: #d9ead3;">
          <td colspan="7" style="text-align: right; padding: 8px; border: 1px solid #000;">Grand Total</td>
          <td style="padding: 8px; text-align: right; border: 1px solid #000;">{{ price | number: '1.2-2' }}</td>
          <td style="padding: 8px; text-align: right; border: 1px solid #000;">{{ issueCopies | number }}</td>
          <td style="padding: 8px; text-align: right; border: 1px solid #000;">{{ issue_amt | number: '1.2-2' }}</td>
          <td style="padding: 8px; text-align: right; border: 1px solid #000;">{{ discount | number: '1.2-2' }}</td>
          <td style="padding: 8px; text-align: right; border: 1px solid #000;">{{ netamount | number: '1.2-2' }}</td>
          <td style="padding: 8px; text-align: right; border: 1px solid #000;">{{ recivedamt | number: '1.2-2' }}</td>
          <td style="padding: 8px; text-align: right; border: 1px solid #000;">{{ remainingamt | number: '1.2-2' }}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
  </div>
</div>
